/**
 * Наружу у комнаты сессии ровно одна дверь – хост. Поверхности, стор и правило показа остаются
 * внутри: комнату монтируют один раз в корне лейаута, и любой второй вход в фичу означал бы
 * второй экземпляр той же коробки на том же экране.
 */
export { SessionRoomHost } from './components/SessionRoomHost';
export type { SessionRoomPhase } from './components/RoomChrome';
